import { render, staticRenderFns } from "./WidgetSettingsGuide.vue?vue&type=template&id=fb6a891e&scoped=true"
import script from "./WidgetSettingsGuide.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsGuide.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsGuide.vue?vue&type=style&index=0&id=fb6a891e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a891e",
  null
  
)

export default component.exports